export enum AutomationDeployAs {
  AUTOMATION = 'AUTOMATION',
  FLOW = 'FLOW',
}
